import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownRendererProps {
  children?: string;
  classname?: string;

  inline?: boolean;
}

export function MarkdownRenderer({
  children,
  classname,
  inline = false,
}: MarkdownRendererProps) {
  return (
    <ReactMarkdown
      className={classname}
      components={{ ...(inline ? {} : {}) }}
      linkTarget="_blank"
    >
      {children}
    </ReactMarkdown>
  );
}
